(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const tabs = document.querySelectorAll('.custom-tab');
    const tabContents = document.querySelectorAll('.custom__tab-content');

    if (!tabs || tabs.length === 0) return;

    function activateTab(clickedTab) {
      const contentId = clickedTab.dataset.contentId;
      const contentEl = document.getElementById(contentId);

      // Deactivate all contents and tabs
      tabContents.forEach(function(c){
        c.classList.remove('active');
        c.setAttribute('aria-hidden', 'true');
      });

      tabs.forEach(function(t){
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });

      // Activate clicked ones
      clickedTab.classList.add('active');
      clickedTab.setAttribute('aria-selected', 'true');
      if (contentEl) {
        contentEl.classList.add('active');
        contentEl.setAttribute('aria-hidden', 'false');
      }
    }

    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        activateTab(this);
      });

      tab.addEventListener('keydown', function(e){
        // Allow Enter or Space to activate
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateTab(this);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
